import React, { FC } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Stack, Typography } from "@mui/material";
import { usePageCrumb } from "../../../../context/PageCrumbContext";
import YourQuote from "../../your-quote/YourQuote";
import { iContentHeaderProps } from "../../../../types/contentType";
import Button from "@mui/material/Button";
import FilterBtnIcon from "../../../../assets/svg-fc/FilterBtnIcon";
import "./contentHeader.scss";

const ContentHeader: FC<iContentHeaderProps> = ({
	contentHeaderTitle,
	welcomeTitleName,
	breadCrumbsHref,
	breadCrumbsLinkTitle,
	breadCrumbsCurrentTitle,
	yourQuote,
	yourQuotePrice,
	createdBy,
	ordNumber,
	filterBtn,
	filterAppliedModalClick,
	applyfiltersActiveClass = "",
}) => {
	// The breadcrumb lives in the app header now — this page's name (and its list) become its last crumbs.
	usePageCrumb(breadCrumbsCurrentTitle, breadCrumbsHref, breadCrumbsLinkTitle);
	return (
		<>
			<Box className="contentHeader">
				<Grid
					container
					spacing={0}
					className={`content_header_hold ${
						filterBtn ? "grid" : "block"
					}`}
					sx={{
						justifyContent: "space-between",
						alignItems: "center",
						flexWrap: "unset",
						display: "grid",
						gridTemplateColumns: "1fr auto",
						gap: "30px"
					}}>
					<Grid>
						<Typography variant="h1">
							{contentHeaderTitle}
						</Typography>
						{welcomeTitleName && (
							<span className="welcomeTitle">
								Welcome back, {welcomeTitleName}!
							</span>
						)}
					</Grid>
					<Grid
						container
						className="quoteCreated"
						sx={{
							justifyContent: "flex-end"
						}}
					>
						<Stack
							direction="row"
							spacing={3}
							className="quoteCreatedHold"
							sx={{
								alignItems: "center"
							}}
						>
							<YourQuote
								yourQuote={yourQuote}
								yourQuotePrice={yourQuotePrice}
							/>
							{(createdBy || ordNumber) && (
								<Box className="contentHeaderCreatedBy">
									{createdBy && (
										<small>
											<span>Created By {createdBy}</span>
										</small>
									)}
									{ordNumber && (
										<span>ORD # {ordNumber}</span>
									)}
								</Box>
							)}
							{filterBtn && (
								<>
									<Button
										type="button"
										aria-label="Search Filter Button"
										className={`filter_btn ${applyfiltersActiveClass}`}
										onClick={filterAppliedModalClick}
									>
										<FilterBtnIcon />
									</Button>
								</>
							)}
						</Stack>
					</Grid>
				</Grid>
			</Box>
		</>
	);
};
export default ContentHeader;
